export default function Configurazione() {
    const globalix: Global = {
        apiBaseUrl: (window as any).globalConfig?.appurl || 'http://localhost:2006/MarbleR2.WebApi/api/',
        companyname: (window as any).globalConfig?.companyname,
        idsocieta: (window as any).globalConfig?.idSocieta,
        maxResultsPerPage: 12,
    };

    return globalix;
}

interface Global {
    apiBaseUrl: string;
    companyname: string;
    idsocieta: number;
    maxResultsPerPage: number;
}
